import React, { useEffect, useState } from "react";
import GenericReject from "../GenericReject/reject";
import bacsService from "../../../services/bacs/bacs.service";
import { useToast } from "../../../hooks";

const initalFormState = {
  cancel_reason_id: "",
  cancel_reason: "",
};

const RejectBacs = (props) => {
  const [reasons, setReasons] = useState([]);
  const [fields, setFields] = useState(initalFormState);
  const addToast = useToast();
  const {
    handleClose,
    refresh,
    id,
    getCancelReasons = () => bacsService.getCancelReasons(),
  } = props;

  const getAllCancelReasons = async () => {
    try {
      const response = await getCancelReasons();
      if (response.status === 200) {
        setReasons(response.data.response);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const submit = async () => {
    const status = reasons.filter((x) => x.value == fields.cancel_reason_id)[0]
      .status_id;

    const data = {
      id: id,
      status_id: status,
      cancel_reason_id: fields.cancel_reason_id,
      cancel_reason: fields.cancel_reason,
    };

    const response = await bacsService.update(data);
    if (response.status === 200) {
      addToast({
        variant: "success",
        header: "BACS - Desafectación",
        body: "Se actualizó la información correctamente",
      });
      handleClose();
      refresh();
    }
  };

  const onSimpleFieldChange = (fieldName, fieldValue) => {
    setFields({
      ...fields,
      [fieldName]: fieldValue,
    });
  };

  useEffect(() => {
    getAllCancelReasons();
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      {reasons.length > 0 && (
        <GenericReject
          reasons={reasons}
          handleOnChange={onSimpleFieldChange}
          submit={submit}
          fields={fields}
          {...props}
        />
      )}
    </div>
  );
};

export default RejectBacs;
